export default {
  "settings": "Settings",
  "settings.profile": "Profile",
  "settings.team": "Team",
  "settings.notifications": "Notifications",
};
